<template>
<!-- <v-parallax src="../assets/parallex.jpg" height="100%" > -->
    <section class="page-section" id="careers">
    <div class="container">
      
            
<v-card dark raised
    class="mx-auto"><div class="row">
        
        
      
        
      
    
        <div class="col-lg-12 text-center">
          <h2 class="section-heading text-uppercase" style="color:#ea1e29" >Careers</h2>
        </div>
      </div><v-card-text ><h6 >As you probably know by now, MAYExports is part of a bigger retail chain. This makes us one of the fastest growing export companies in Vietnam. Therefore, in order to continue thriving, we are constantly in the lookout for new talent that is motivated and can superseed expectations. </h6>   </v-card-text>
      
    <v-expansion-panels accordion hover  popout>
      <v-expansion-panel
        v-for="(item,i) in qandaJSON"
        :key="i"
      >
        <v-expansion-panel-header class="font-weight-light" >{{item.question}}</v-expansion-panel-header>
        <v-expansion-panel-content class="font-weight-light" >{{item.answer}}
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
     
     
      <!-- <div class="row">
        <div class="col-md-4 col-sm-6"  v-for="(obj,key) in serviceJSON" :key="key">
     
        <v-card light
    class="mx-auto"
    max-width="800"
    style="padding-top:10px;"
  >
    <v-img
      class="white--text align-end"
      height="200px"
      :src="obj.serviceImg"
    >
      
    </v-img>
<v-card-title>{{obj.serviceTitle}}</v-card-title>
    <v-card-subtitle class="pb-0">{{obj.serviceText}}</v-card-subtitle>

    <v-card-text class="text--primary">
      

      <div style="color:#392F51">{{obj.serviceDate}}</div>
    </v-card-text>

    <v-card-actions>
      <v-btn
        color="#392F51"
        text
        href="https://www.gulfood.com/" target="_blank"
      >
        View
      </v-btn>

      
    </v-card-actions>
  </v-card>
        </div>
      </div>
     -->
    </div>

  </section>
  <!-- </v-parallax> -->
</template>
<script>
export default {
    data:()=>({
      qandaJSON:[{
        question:"Q: How to apply?",
        answer:"A: Please send us your resume at info@mayexports.co.vn",
        
      },
      
      {
        question:"Q: How long before I get feedback?",
        answer:"A: Once you have sent in your resume, our Talent acquisition team will process your resume and get back to you within 5 working days.",
        
      },
      ],
      isActive:false
    })
}
</script>
<style scoped>

</style>